<template>
  <section>
    <div class="notification warning">
      <p>
        <strong>You are currently logged in as - ({{ email }}),
          please <a :href="`${DASHBOARD_URL}/admin/users/remove_session`">click here</a> to return to normal.</strong>
      </p>
      <p><strong>Warning:</strong> Track copyright infringement validation is now being overridden by Admin.</p>
    </div>
  </section>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'ImpersonateNotification',
  data() {
    return {
      DASHBOARD_URL: process.env.VUE_APP_DASHBOARD_URL || 'https://dashboard.dittomusic.com',
    }
  },
  computed: {
    ...mapState({
      email: state => state.user.email,
    }),
  },
}
</script>
